<template>
  <ai-image class="AiCarouselImageItem" v-bind="props" />
</template>

<script setup lang="ts">
type Props = {
  src?: string;
  srcSet?: string | undefined;
  alt?: string;
  decorative?: boolean;
};

const props = defineProps<Props>();
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/functions' as func;

.AiCarouselImageItem {
  height: func.calcRem(200);

  @media (mq.$from-medium) {
    height: func.calcRem(355);
  }
}
</style>
